import React, {useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';

import "../PaginaCustomer.css";
import "../content-styles.css"

import Swal from 'sweetalert2'

import * as Hosts from '../../../Hosts';
import {
	reqGET,
    //reqPOST,
    profile_access,
    //functionSendMail,
    reqPUT

} from '../../../Utils';

import { usarToken } from "../../../UseToken";

import Loader from '../../../loader'

import Navbar from "../Navbar/Navbar_00";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Footer from "../Footer/Footer_00";

import { language } from './Language';

export default function Perfil(props) {
    const [, set_dados] = useState(null);
    const notifications_list = useRef(null);
    const notifications_client_list = useRef(null);
    const clients_list = useRef(null);
    const is_logged_in = useRef(null);

    //const user_info = useRef({});

    const [user_access_level, set_user_access_level] = useState(0)
    const [selected_user_id, set_selected_user_id] = useState('')

    const [dados_config, set_dados_config] = useState({});
    const [dados_navbar, set_dados_navbar] = useState({});

	const [isloading, setLoading] = useState(true)
    const [loading_table, /*set_loading_table*/] = useState(false);

    const [lang, set_lang] = useState('pt');

    const [, setRefresh] = useState(0)
    
    useEffect(() => {

        (async () => {

            set_dados(notifications_client_list.current = [])

            let temp_token_info = await usarToken().getToken()
            let token_info = JSON.parse(temp_token_info)

            if(token_info !== undefined && token_info !== null && token_info.user_info !== undefined) {

                let profile_access_aux = profile_access.find(el => el.name.toLowerCase() === token_info.user_info.profile.toLowerCase())
                if(profile_access_aux !== undefined && profile_access_aux !== null) {
                    set_user_access_level(profile_access_aux.level)
                }

                set_dados(is_logged_in.current = true)
            }
            else {
                set_dados(is_logged_in.current = false)
            }

            if(is_logged_in.current) {
                if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                    set_dados_navbar(props.dados_navbar)
                }
            }

            if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                set_dados_config(props.dados_config)
            }

            let getNotifications = async (user_id) => {
                let res = await reqGET(`${Hosts.SIMCore_API}/web/client/notification/user/${Hosts.companycode}/${user_id}`)
                return res.data

            }
            if (token_info !== undefined && token_info !== null && token_info.user_info !== undefined && token_info.user_info !== null && token_info.user_info.id !== '') {

                let res_n = []

                if(props?.location?.state?.item !== undefined && props?.location?.state?.item !== null && props?.location?.state?.item !== '') {
                    res_n = await getNotifications(props.location.state.item)
                    set_selected_user_id(props.location.state.item)
                    set_dados(notifications_client_list.current = res_n)
                }
                else {
                    res_n = await getNotifications(token_info.user_info.id)                
                    set_dados(notifications_list.current = res_n)
                }

                setLoading(false)
            }
            
            let getClients = async () => {
                let res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${Hosts.companycode}/Cliente`)
                set_dados(clients_list.current = res.data)
            }
            if (token_info !== undefined && token_info !== null && token_info.user_info !== undefined && token_info.user_info !== null && token_info.user_info.id !== '') {
                await getClients()
            }

        })()

        if(localStorage.getItem('lang') !== undefined  || localStorage.getItem('lang') !== null) {
            set_lang(localStorage.getItem('lang'))
        }

    }, [props]);

    const show_notification = async (el) => {

        let html_content = '' + 
            '<div class="pt-4 px-3 text-start">' +
                '<h4>' + el.info.title + '</h4>' +
                '<br/>' +
                '<p>' + el.info.message + '</p>' +
            '</div>'

        Swal.fire({
            title: "",
            icon: "",
            html: html_content, 
            confirmButtonColor: "var(--primary)",
            confirmButtonText: "" + language[lang].btn_continue + "",
            focusConfirm: false,
            showCloseButton: true,
        });

        if(parseInt(user_access_level) < 5) {
            let today = new Date();
            let _day = String(today.getDate()).padStart(2, '0') 
            let _month = String(today.getMonth() + 1).padStart(2, '0')
            let _year = today.getFullYear()

            let _hour = String(today.getHours()).padStart(2, '0')
            let _minutes = String(today.getMinutes()).padStart(2, '0')

            if(el.info['read_date'] === '') {
                let not_aux = await reqGET(`${Hosts.SIMCore_API}/web/client/notification/${Hosts.companycode}/${el.id}`)
                if(not_aux !== undefined && not_aux !== null && not_aux.data.length > 0) {

                    not_aux.data[0].info.state = '1'
                    not_aux.data[0].info['read_date'] = today
                    el.info['read_date'] = _year + '-' + _month + '-' + _day + ' ' + _hour + ':' + _minutes

                    await reqPUT(`${Hosts.SIMCore_API}/web/client/notification`, not_aux.data[0])
                }
            }

            setRefresh(r => r + 1)
        }

    }

    const filter_for_client = async (e) => {
        const { value } = e.target;

        set_selected_user_id(value)

        let notification_by_user = await getNotificationsByUser(value)

        set_dados(notifications_client_list.current = notification_by_user)

    }

    let getNotificationsByUser = async (user_id) => {
        let res = await reqGET(`${Hosts.SIMCore_API}/web/client/notification/user/${Hosts.companycode}/${user_id}`)

        return res.data
    }

    const columns = [
        {
            name: language[lang].field_title,
            selector: 'info.title',
            sortable: true,
            left: true,
            maxWidth: '75%',
            minWidth: '250px',
        },
        {
            name: language[lang].field_date,
            selector: 'info.date',
            sortable: true,
            center: true,
            maxWidth: '10%',
            minWidth: '180px',
        },
        {
            name: language[lang].field_date_read,
            selector: 'info.read_date',
            sortable: true,
            center: true,
            maxWidth: '10%',
            minWidth: '180px',
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            minWidth: '80px',
            maxWidth: '5%',
            cell: row => 
                <span>
                    <i className={"bi bi-eye fs-5"} style={{cursor: 'pointer'}} onClick={() => show_notification(row) }></i>
                    <i className="bi bi-trash fs-5 d-none" style={{cursor: 'pointer'}} onClick={() => {}}></i>
                </span>
        },
    ]

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    }

    return (
        isloading ?
            <Loader />
        :
            <>

                <Navbar pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
                <Breadcrumb /> 
                <main className='notifications-list mb-5'>
                    <div className="container-fluid">
                        <div className="row">
                            <div className='col-12 bg-light py-5'>
                                <div className='container'>
                                    <div className='row'>
                                        <div className='col-12 text-center'>
                                            <h3 className="titulo-primario">
                                                {language[lang].notifications_list}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className='row'>
                            <div className='col-12 col-md-8 mx-auto'>
                                {
                                    user_access_level >= 5 && clients_list.current !== null ?
                                        <div className='row'>
                                            <div className='col-12 col-sm-6 col-md-4 mt-5'>
                                                <select className="form-select" aria-label="Select client" name='tipo' value={selected_user_id} onChange={(e) => filter_for_client(e)}>
                                                    <option value="">{language[lang].choose_client}</option>
                                                    {
                                                        clients_list.current.map((v, k) => {
                                                            return (
                                                                <option key={k} value={v.id}>{v.info.name}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            </div>
                                    :
                                        null
                                }  
                                {
                                    user_access_level < 5 ?
                                        <div className='mt-5'>
                                            <DataTable
                                                columns={columns}
                                                data={notifications_list.current}
                                                noDataComponent={loading_table ? language[lang].table_loading : language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </div>
                                    :
                                        <div className='mt-5'>
                                            <DataTable
                                                columns={columns}
                                                data={notifications_client_list.current}
                                                noDataComponent={loading_table ? language[lang].table_loading : language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </div>
                                    }
                            </div>
                        </div>

                    </div>
                </main>
                <Footer pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
            </>

    );
}